/* ═══════════════════════════════════════════════════════════════════
   Tema ON Móveis · coleção.

   Só carrega em template.name == 'collection', depois do onm.js: gaveta
   de filtros, "ver mais produtos" e o "ler mais" da descrição. Usa
   ONM.trava do onm.js.
   ═══════════════════════════════════════════════════════════════════ */

try {
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ── gaveta de filtros ────────────────────────────────────────────
     Cada clique aplica na hora, sem recarregar a página. O tema pede a
     mesma URL que o Shopify usaria, lê a resposta e troca só três
     pedaços: a grade, os chips e o corpo do filtro. Como o corpo vem do
     servidor já com as contagens novas, as combinações que não existem
     chegam desabilitadas e não dá para marcar. Sem JS, o formulário
     continua enviando do jeito antigo.
     ─────────────────────────────────────────────────────────────── */
  var filtros = $('#onmFiltros');
  if (filtros) {
    var abreFiltro = function () {
      filtros.hidden = false;
      requestAnimationFrame(function () { filtros.classList.add('on'); });
      ONM.trava(true);
      if (ONM.foco) ONM.foco.prende(filtros);
      var fx = filtros.querySelector('.gav__x'); if (fx) fx.focus({ preventScroll: true });
    };
    var fechaFiltro = function () {
      filtros.classList.remove('on');
      ONM.trava(false);
      if (ONM.foco) ONM.foco.solta(filtros);
      setTimeout(function () { filtros.hidden = true; }, 340);
      var ab = document.querySelector('[data-abrefiltro]'); if (ab) ab.focus({ preventScroll: true });
    };
    $$('[data-abrefiltro]').forEach(function (b) { b.addEventListener('click', abreFiltro); });
    $$('[data-fechafiltro]', filtros).forEach(function (b) { b.addEventListener('click', fechaFiltro); });
    filtros._fecha = fechaFiltro;

    var grade = $('#colGrade'), chips = $('#colChips'), corpo = $('#filtroCorpo');
    var esperando = null, pedido = 0;

    function urlDoForm() {
      var f = $('#formFiltro');
      if (!f) return location.href;
      var q = [];
      $$('input, select', f).forEach(function (c) {
        if (c.disabled || !c.name) return;
        if ((c.type === 'checkbox' || c.type === 'radio') && !c.checked) return;
        if (c.value === '' || c.value == null) return;
        q.push(encodeURIComponent(c.name) + '=' + encodeURIComponent(c.value));
      });
      return f.getAttribute('action') + (q.length ? '?' + q.join('&') : '');
    }

    function aplica(url, empurra) {
      var meu = ++pedido;
      if (grade) grade.classList.add('carrega');
      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (meu !== pedido) return;                 // chegou fora de ordem: descarta
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var troca = function (el, id) {
            var novo = doc.getElementById(id);
            if (el && novo) el.innerHTML = novo.innerHTML;
          };
          troca(grade, 'colGrade');
          troca(chips, 'colChips');
          troca(corpo, 'filtroCorpo');
          // v160: a quantidade ao lado do título acompanha o filtro
          var qn = doc.querySelector('[data-qtd]'), qv = $('[data-qtd]');
          if (qv) { qv.textContent = qn ? qn.textContent : ''; qv.hidden = !qn; }
          var n = doc.querySelector('[data-ativos]');
          $$('[data-ativos]').forEach(function (b) {
            b.textContent = n ? n.textContent : '0';
            b.hidden = !n || n.hidden || n.textContent.trim() === '0';
          });
          if (empurra !== false) history.pushState({ filtro: 1 }, '', url);
          if (grade) grade.classList.remove('carrega');
          liga();                                     // religa o que foi trocado
          document.dispatchEvent(new CustomEvent('onm:cards'));   // pinta as notas dos novos
        })
        .catch(function () {
          if (grade) grade.classList.remove('carrega');
          location.href = url;                        // se a rede falhar, vai do jeito antigo
        });
    }

    // religa tudo que vive dentro dos pedaços trocados
    function liga() {
      var formF = $('#formFiltro');
      if (!formF) return;

      // faixa de preço: dois cursores e dois campos, sempre em sincronia
      $$('[data-faixa]', filtros).forEach(function (f) {
        var lo = $('[data-lo]', f), hi = $('[data-hi]', f), nlo = $('[data-nlo]', f), nhi = $('[data-nhi]', f);
        var max = +lo.max || 1;
        var desenha = function () {
          var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
          f.style.setProperty('--a', (a / max * 100) + '%'); f.style.setProperty('--b', (b / max * 100) + '%');
          nlo.value = a > 0 ? a : ''; nhi.value = b < max ? b : '';
        };
        lo.addEventListener('input', desenha); hi.addEventListener('input', desenha);
        nlo.addEventListener('change', function () { lo.value = Math.min(+nlo.value || 0, +hi.value); desenha(); });
        nhi.addEventListener('change', function () { hi.value = Math.max(+nhi.value || max, +lo.value); desenha(); });
      });

      // qualquer mudança aplica sozinha, com uma pausa curta para o preço
      formF.addEventListener('change', function (e) {
        var alvo = e.target;
        if (alvo.type === 'range') return;            // o range só aplica ao soltar, abaixo
        clearTimeout(esperando);
        esperando = setTimeout(function () { aplica(urlDoForm()); }, 60);
      });
      $$('[data-faixa] input[type="range"]', filtros).forEach(function (r) {
        var solta = function () { clearTimeout(esperando); esperando = setTimeout(function () { aplica(urlDoForm()); }, 200); };
        r.addEventListener('change', solta);
      });
      formF.addEventListener('submit', function (e) {
        e.preventDefault();                           // já está aplicado: o botão só fecha
        fechaFiltro();
      });
    }
    liga();

    /* ── ver mais produtos ──────────────────────────────────────────
       Pede só esta seção pela API de renderização e encaixa os cartões
       novos no fim da grade. O botão é um link de verdade para a página
       seguinte, então sem JS a navegação continua funcionando.
       ───────────────────────────────────────────────────────────── */
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-mais]') : null;
      if (!b || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (b.dataset.carregando === '1') return;
      var url = b.dataset.prox;
      var caixa = b.closest('[data-mais-caixa]');
      if (!url || !caixa) return;

      b.dataset.carregando = '1';
      b.classList.add('colmais__b--carrega');
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + sep + 'section_id=' + encodeURIComponent(caixa.dataset.secao), { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { if (!r.ok) throw 0; return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grade = document.querySelector('#colGrade .grade');
          var novos = doc.querySelectorAll('.grade > .card');
          if (!grade || !novos.length) throw 0;
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(novos, function (c) { frag.appendChild(document.importNode(c, true)); });
          grade.appendChild(frag);

          var proxBtn = doc.querySelector('[data-mais]');
          var vistos = grade.querySelectorAll('.card').length;
          var total = parseInt(caixa.dataset.total, 10) || vistos;
          if (proxBtn) {
            b.dataset.prox = proxBtn.dataset.prox;
            b.setAttribute('href', proxBtn.getAttribute('href'));
            var cont = caixa.querySelector('[data-mostrados]');
            if (cont) cont.textContent = vistos;
          } else {
            b.remove();
            var c2 = caixa.querySelector('[data-mostrados]');
            if (c2) c2.textContent = total;
          }
          history.replaceState(null, '', url);      // recarregar traz o que já foi visto
          document.dispatchEvent(new CustomEvent('onm:cards'));
        })
        .catch(function () { location.href = url; })
        .then(function () {
          b.dataset.carregando = '0';
          b.classList.remove('colmais__b--carrega');
        });
    });

    // chips, paginação e limpar também trocam por dentro
    document.addEventListener('click', function (e) {
      var a = e.target.closest('#colChips a, #colGrade .pag a, .gav__f--filtro .mini');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      aplica(a.href);
      if (a.closest('.gav__f--filtro')) fechaFiltro();
    });
    addEventListener('popstate', function () { aplica(location.href, false); });
  }

  /* ── descrição da coleção: algumas linhas e "ler mais" ────────── */
  var lm = $('[data-lermais]');
  if (lm) {
    var lmc = $('.col-desc__c', lm), lmb = $('[data-lermais-b]', lm);
    if (lmc.scrollHeight <= lmc.clientHeight + 4) lmb.hidden = true;
    lmb.addEventListener('click', function () { lm.classList.add('aberta'); lmb.hidden = true; });
  }

})();
} catch (e) { if (window.console && console.warn) console.warn('ON: um bloco do tema falhou e o resto seguiu.', e); }
